import { render, staticRenderFns } from "./GastroReportBowelCleanseForms.vue?vue&type=template&id=2dd7953a&"
import script from "./GastroReportBowelCleanseForms.vue?vue&type=script&lang=js&"
export * from "./GastroReportBowelCleanseForms.vue?vue&type=script&lang=js&"
import style0 from "./GastroReportBowelCleanseForms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VContainer,
  VFlex,
  VLayout,
  VTextarea,
})
